import { createSelector } from '@ngrx/store';

import { IgenomicsState } from '../../core/interfaces/genomics-state.interface';
import { ITablelistState } from './tablelist.state';

export const selectTablelistFeature = (state: IgenomicsState): ITablelistState => state.tablelist;

export const selectTablelistListFeature = createSelector(selectTablelistFeature, (configurationTemplate) => configurationTemplate.list);

export const selectTablelistFeatureConfig = (resource: string) => {
  return createSelector(selectTablelistListFeature, (configurationTemplate) => (configurationTemplate[resource]) ? configurationTemplate[resource].config : null);
};

export const selectTablelistFeatureType = (props) => {
  return createSelector(selectTablelistListFeature, (configurationTemplate) => (configurationTemplate[props.configTemplateType]) ? configurationTemplate[props.configTemplateType] : null);
};

export const selectTablelistFeatureAmount = (resource: string) => {
  return createSelector(selectTablelistListFeature, (configurationTemplate) => {
    return configurationTemplate[resource]
      ? configurationTemplate[resource].amount
      : null;
  });
};
